import apiClient from 'utilities/apiClient';

export const signin = (payload) => {
  return apiClient.post(`${apiClient.Urls.signin}`, payload);
};

export const signout = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.signout}/${url}`, payload, true);
};

export const generateKey = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.licenseKey}/${url}`, payload, true);
};
